import { useContext } from 'react'
import { Controller } from 'react-hook-form'

import { FormContext } from '../Contexts'

import { AnyMaskedOptions, TextMaskField } from './TextMaskField'

const TextMaskFieldRegistered = ({
  name,
  label,
  mask,
  unmask,
  lazy,
  blocks,
  required,
}: {
  name: string
  label: string
  mask: string | ((value: any) => string)
  unmask?: boolean | 'typed'
  lazy?: boolean
  blocks?: { [key: string]: AnyMaskedOptions }
  required?: boolean
}) => {
  const { control } = useContext(FormContext)

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, ...rest }) => (
        <TextMaskField
          {...field}
          required={required}
          value={field.value?.toString()}
          label={label}
          mask={typeof mask === 'function' ? mask(field.value) : mask?.toString()}
          unmask={unmask || true}
          onAccept={field.onChange}
          lazy={lazy}
          blocks={blocks}
        />
      )}
    />
  )
}

export { TextMaskFieldRegistered }
